module.exports = __webpack_public_path__ + "static/media/4.2bc877a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/bobruisk/4.jpg
// module id = 213
// module chunks = 0